import { registerComponent } from '@gig/magic-common';
import MessageComponent from './message.vue.js';

var Message = registerComponent(MessageComponent);

export { Message };
